if (window.trans) {

    let infoTranslations = ''

    if(document.documentElement.lang == 'cn'){
        infoTranslations = window.trans.lms.Show + ' _TOTAL_ ' + window.trans.lms.Entries_cn + ' _START_ ' + window.trans.lms.Of_cn + ' _END_ ' + window.trans.lms.Individual_cn;
    }else{
        infoTranslations = window.trans.lms.Showing + ' _START_ ' + window.trans.lms.to + ' _END_ ' + window.trans.lms.of + ' _TOTAL_ ' + window.trans.lms.entries;
    }

    // Generate datatables buttons according to configuration passed
    window.setDatatablesButtons = function(additionalParameters={}, enabledButtons=['excel', 'csv', 'pdf', 'print', 'copy', 'visibility', 'reorder'], enabledSections=['regular_export', 'options']){

        let buttons                 = [];
        let regularExportButtons    = [];
        let optionButtons           = [];

        // All regular export options dropdown
        if(enabledSections.includes('regular_export')){

            // Meeting excel export (meetings have specific export which must be modified)
            if(enabledButtons.includes('meeting_excel')){
                regularExportButtons.push(
                    {
                        extend      : 'excelHtml5',
                        className   : 'neutral',
                        text        : '<i class="fa-solid fa-file-excel"></i> ' + window.trans.lms.DatatablesButtonsRegularExcel,
                        // Customization of export file
                        customize   : function(xlsx){
                            var sheet       = xlsx.xl.worksheets['sheet1.xml'];
                            // Move down rows to have place for our custom data
                            var downrows    = 4;
                            var clRow       = $('row', sheet);
        
                            clRow.each(function () {
        
                                var attr    = $(this).attr('r');
                                var ind     = parseInt(attr);
                                ind         = ind + downrows;
        
                                $(this).attr("r",ind);
        
                            });
        
                            $('row c ', sheet).each(function () {
        
                                var attr    = $(this).attr('r');
                                var pre     = attr.substring(0, 1);
                                var ind     = parseInt(attr.substring(1, attr.length));
                                ind         = ind + downrows;
        
                                $(this).attr("r", pre + ind);
        
                            });
        
                            // Add single row
                            function Addrow(index,data) {
        
                                msg='<row r="'+index+'">'
        
                                for(i=0;i<data.length;i++){
        
                                    var key     = data[i].k;
                                    var value   = data[i].v;
        
                                    msg += '<c t="inlineStr" r="' + key + index + '">';
                                    msg += '<is>';
                                    msg +=  '<t>'+value+'</t>';
                                    msg+=  '</is>';
                                    msg+='</c>';
        
                                }
        
                                msg += '</row>';
        
                                return msg;
        
                            }
        
                            //Add rows
                            // Seminar name
                            var r1 = Addrow(1, [{ k: 'A', v: '' }, { k: 'B', v: seminarName }, { k: 'C', v: '' }, { k: 'D', v: '' }]);
                            // Meeting name / start / end
                            var r2 = Addrow(2, [{ k: 'A', v: '' }, { k: 'B', v: meetingName }, { k: 'C', v: meetingStart }, {k: 'D', v: meetingEnd}]);
                            // Meeting type
                            var r3 = Addrow(3, [{ k: 'A', v: '' }, { k: 'B', v: meetingType }, { k: 'C', v: '' }]);
        
                            // Add to excel
                            sheet.childNodes[0].childNodes[1].innerHTML = r1 + r2+ r3+ sheet.childNodes[0].childNodes[1].innerHTML;
        
                            // Change cells width
                            var col = $('col', sheet);
                            col.each(function () {
                                if($(this).attr('min') != 1){
                                    $(this).attr('width', 30);
                                }
                            });
        
                            // Add style to first (autoincrement) column
                            $('row c[r^="A"]', sheet).attr( 's', '51' );
        
                        },
                        exportOptions:{
                            // All exportable columns
                            columns     : ':not([data-custom-exportable="false"]):visible, :not([data-custom-exportable="false"]).dtr-hidden, .signature-column',
                            // Type used in render function
                            orthogonal  : 'custom_export',
                            format      : {
                                header: function ( data, columnIdx ) {
        
                                    try {
        
                                        if (data.includes('<span')) {
                                            data = $(data).html(data).text();
                                        }
        
                                    }catch(err) {
                                        console.log("Error: ", err)
                                    }
        
                                    if(window.global_vars.env.CLIENT == 'CEWE'){
        
                                        if(columnIdx === 0){
                                            data = "";
                                        }
        
                                        if(data == "Picture"){
                                            data = "Standort";
                                        }
        
                                        if(data === "Signature"){
                                            data = "Abteilung";
                                        }
        
                                        return data;
        
                                    }else{
                                        return columnIdx === 0 ? "" : data;
                                    }
                                },
                                body: exportColumnData,
                            }
                        },
                        title:'', // To remove title from excel file (we don't need it because we use our custom data)
                        filename:additionalParameters.meetingName
                    }
                );
            }

            // Custom rooms plan excel export
            if(enabledButtons.includes('rooms_plan_excel')){
                regularExportButtons.push({
                    extend          : 'excelHtml5',
                    text            : '<i class="fa-solid fa-file-excel"></i> ' + window.trans.lms.DatatablesButtonsRegularExcel,
                    className       : 'neutral', 
                    title           : window.global_vars.env.APP_NAME + '-' + window.trans.lms.RoomsPlan,
                    exportOptions   : {
                        // All exportable columns
                        columns     : ':not([data-custom-exportable="false"]):visible, :not([data-custom-exportable="false"]).dtr-hidden',
                        // Type used in render function
                        orthogonal  : 'rooms_plan_export',
                    },
                    customize: function (xlsx) {
                        var sheet = xlsx.xl.worksheets['sheet1.xml'];
    
                        // Enable text wrapping in Excel
                        $('row c[r]', sheet).attr('s', '55');
    
                        // Create a regex using the translated capacity label
                        var capacityRegex = new RegExp('(' + window.trans.lms.Capacity + ':\\s*)\\n+\\s*', 'g');
    
                        // Process each cell's content
                        $('row c[r] t', sheet).each(function () {
    
                            var text = $(this).text();
    
                            // Remove all extra spaces and blank lines
                            text = text.replace(capacityRegex, '$1')    // Remove newline after "Capacity:"
                                        .replace(/[ \t]+/g, ' ')         // Replace multiple spaces with a single space
                                        .replace(/\n\s+/g, '\n')         // Remove leading spaces from new lines
                                        .trim();                         // Final cleanup
    
                            $(this).text(text); 
                        });
                    }
                });
            }

            // Regular excel export
            if(enabledButtons.includes('excel')){
                regularExportButtons.push({
                    extend          : 'excelHtml5',
                    className       : 'neutral',
                    text            : '<i class="fa-solid fa-file-excel"></i> ' + window.trans.lms.DatatablesButtonsRegularExcel,
                    title           : window.exportFileName ? window.exportFileName : '',
                    exportOptions   :{
                        // All exportable columns
                        columns     : ':not([data-exportable="false"]):visible, :not([data-exportable="false"]).dtr-hidden',
                        // Type used in render function
                        orthogonal  : 'export',
                        format: {
                            body: exportColumnData,
                        }
                    }
                });
            }

            // Csv export
            if(enabledButtons.includes('csv')){
                regularExportButtons.push({
                    extend          : 'csvHtml5',
                    className       : 'neutral',
                    text            : '<i class="fa-solid fa-file-csv"></i> ' + window.trans.lms.DatatablesButtonsRegularCsv,
                    exportOptions   :{
                        // All exportable columns
                        columns     : ':not([data-exportable="false"]):visible, :not([data-exportable="false"]).dtr-hidden',
                        // Type used in render function
                        orthogonal  : 'export',
                        format: {
                            body: exportColumnData,
                        }
                    }
                });
            }

            // Pdf export
            if(enabledButtons.includes('pdf')){
                regularExportButtons.push({
                    extend          : 'pdfHtml5',
                    className       : 'neutral',
                    text            : '<i class="fa-solid fa-file-pdf"></i> ' + window.trans.lms.DatatablesButtonsRegularPdf,
                    exportOptions   :{
                        // All exportable columns
                        columns     : ':not([data-exportable="false"]):visible, :not([data-exportable="false"]).dtr-hidden',
                        // Type used in render function
                        orthogonal  : 'export',
                        format: {
                            body: exportColumnData,
                        }
                    },
                    customize: function (doc) {
                        const tableNode = doc.content.find(item => item.table);
                        if (!tableNode || !tableNode.table.body.length || !tableNode.table.body[0].length) {
                            return;
                        }
                        const tableBody = tableNode.table.body;

                        // add "Unterschrift" headers
                        if(window.global_vars.env.CLIENT == 'FRAPORT') {
                            tableBody[0].push({ text: 'Unterschrift', style: 'tableHeader' });
                            tableBody[0].push({ text: 'Unterschrift', style: 'tableHeader' });

                            // add empty columns for each data row
                            for (let i = 1; i < tableBody.length; i++) {
                                tableBody[i].push('');
                                tableBody[i].push('');
                            }
                        }

                        // Explicit widths keep wide tables within the printable page.
                        // Auto widths can exceed the page even in landscape orientation.
                        const columnCount = tableBody[0].length;
                        const pageSize = columnCount <= 10 ? 'A4' : columnCount <= 18 ? 'A3' : 'A2';
                        const landscapeWidths = {A4: 841.89, A3: 1190.55, A2: 1683.78};
                        const horizontalMargin = 20;
                        const cellPadding = 3;
                        const columnWidth = (landscapeWidths[pageSize] - horizontalMargin * 2) / columnCount - cellPadding * 2;
                        const fontSize = columnCount <= 10 ? 9 : 8;

                        doc.pageSize = pageSize;
                        doc.pageOrientation = 'landscape';
                        doc.pageMargins = [horizontalMargin, 40, horizontalMargin, 40];
                        doc.defaultStyle = {...doc.defaultStyle, fontSize};
                        doc.styles.tableHeader.fontSize = fontSize;
                        doc.styles.tableFooter.fontSize = fontSize;
                        tableNode.table.widths = Array(columnCount).fill(columnWidth);
                        tableNode.layout = {
                            ...tableNode.layout,
                            paddingLeft: () => cellPadding,
                            paddingRight: () => cellPadding
                        };
                        tableBody.forEach(row => row.forEach(cell => {
                            if (cell && typeof cell === 'object') {
                                cell.noWrap = false;
                            }
                        }));

                        let pdfExportData = JSON.parse(sessionStorage.getItem('pdfExportData'))

                        if (pdfExportData) {

                            // add image to header
                            doc['header'] = function() {
                                return {
                                    columns: [
                                        {
                                            text: '',
                                            style: 'header',
                                            alignment: 'left'
                                        },
                                        {
                                            image: pdfExportData.logo,
                                            width: 100,
                                            alignment: 'right'
                                        }
                                    ],
                                    margin: [20, 20, 20, 10]
                                };
                            };

                            // add custom text before table
                            const customTextBlock = [
                                { text: '', margin: [0, 0, 0, 10] },
                                { text: [
                                        { text: window.trans.lms.Seminar + ': ', color: 'blue', fontSize: 12 },
                                        { text: pdfExportData.seminarName, color: '#222222', fontSize: 12 }
                                    ], margin: [0, 0, 0, 4], fontSize: 12 },
                                { text: [
                                        { text: window.trans.lms.Meeting + ': ', color: 'blue', fontSize: 12 },
                                        { text: pdfExportData.meetingName, color: '#222222', fontSize: 12 }
                                    ], margin: [0, 0, 0, 4], fontSize: 12 },
                                { text: [
                                        { text: window.trans.lms.course_t + ': ', color: 'blue', fontSize: 12 },
                                        { text: pdfExportData.meetingLocationType, color: '#222222', fontSize: 12 }
                                    ], margin: [0, 0, 0, 4], fontSize: 12 },

                                { text: [
                                        { text: window.trans.lms.MeetingLocation + ': ', color: 'blue', fontSize: 12 },
                                        { text: pdfExportData.location, color: '#222222', fontSize: 12 }
                                    ], margin: [0, 0, 0, 4], fontSize: 12 },

                                { text: [
                                        { text: window.trans.lms.StatisticsTranslations.created_at_date + ': ', color: 'blue', fontSize: 12 },
                                        { text: pdfExportData.meetingStart, color: '#222222', fontSize: 12 }
                                    ], margin: [0, 0, 0, 4], fontSize: 12 },

                                { text: [
                                        { text: window.trans.lms.MeetingInstructor + ': ', color: 'blue', fontSize: 12 },
                                        { text: pdfExportData.instructors, color: '#222222', fontSize: 12 }
                                    ], margin: [0, 0, 0, 4], fontSize: 12 },

                                { text: '', margin: [0, 0, 0, 10] }
                            ];
                            doc.content.splice(doc.content.indexOf(tableNode), 0, ...customTextBlock);


                        }

                    }
                });
            }

            // Print export
            if(enabledButtons.includes('print')){
                regularExportButtons.push({
                    extend          : 'print',
                    className       : 'neutral',
                    text            : '<i class="fa-solid fa-print"></i> ' + window.trans.lms.DatatablesButtonsRegularPrint,
                    exportOptions   :{
                        // All exportable columns
                        columns     : ':not([data-exportable="false"]):visible, :not([data-exportable="false"]).dtr-hidden',
                        // Type used in render function
                        orthogonal  : 'export',
                        format: {
                            body: exportColumnData,
                        }
                    }
                });
            }

            // Copy table option
            if(enabledButtons.includes('copy')){
                regularExportButtons.push(
                    {
                        extend      : 'copyHtml5',
                        className   : 'neutral',
                        text        : '<i class="fa-solid fa-copy"></i> ' + window.trans.lms.DatatablesButtonsRegularCopy,
                        exportOptions   : {
                            columns: ':not([data-copyable="false"]):visible, :not([data-copyable="false"]).dtr-hidden',
                            format: {
                                body: exportColumnData,
                            }
                        },
                    }
                )
            }

            // Push all enabled buttons to collection
            if(regularExportButtons.length > 1){
                buttons.push(
                    {
                        extend      : 'collection',
                        className   : 'regular-export-buttons-collection neutral',
                        text        : window.trans.lms.DatatablesButtonsCollectionExport,
                        buttons     : regularExportButtons
                    }
                )
            }else{
                buttons.push(regularExportButtons);
            }

        }

        // All options dropdown
        if(enabledSections.includes('options')){
            
            // Change column visibility option
            if(enabledButtons.includes('visibility')){
                optionButtons.push(
                    {
                        extend              : 'colvis',
                        className           : 'neutral',
                        popoverTitle        : window.trans.lms.ColumnVisibilityPopoverTitle,
                        text                : '<i class="fa-solid fa-eye-slash"></i> ' + window.trans.lms.DatatablesButtonsOptionsVisibility,
                        postfixButtons      : ['colvisRestore'], // To restore visibility of columns
                        columns             : ':not([data-visibilityable="false"])', // Which columns to include
                    }
                );
            }

            // Change column order option
            if(enabledButtons.includes('reorder')){
                optionButtons.push(
                    {
                        className           : 'neutral',
                        text                : '<i class="fa-solid fa-up-down-left-right"></i> ' + window.trans.lms.DatatablesButtonsOptionsReorderOff,
                        columns             : ':not([data-reorderable="false"])', // Which columns to include,
                        action              : function(e, dt, button, config) {
                            
                            if(button.hasClass('reorder_enabled')){

                                button.removeClass('reorder_enabled');
                                button.html('<span><i class="fa-solid fa-up-down-left-right"></i> '+window.trans.lms.DatatablesButtonsOptionsReorderOff+'</span>');
                                dt.colReorder.enable(false);
                                $('#'+additionalParameters.tableId+' th:not([data-reorderable="false"])').removeClass('cursor_move');

                            }else{

                                button.addClass('reorder_enabled');
                                button.html('<span><i class="fa-solid fa-up-down-left-right"></i> '+window.trans.lms.DatatablesButtonsOptionsReorderOn+'</span>');
                                dt.colReorder.enable(true);
                                $('#'+additionalParameters.tableId+' th:not([data-reorderable="false"])').addClass('cursor_move');
                                
                            }
    
                        },
                    }
                );
            }

            // Push buttons to collection
            if(optionButtons.length > 1){
                buttons.push(
                    {
                        extend      : 'collection',
                        className   : 'options-buttons-collection neutral',
                        text        : window.trans.lms.DatatablesButtonsCollectionOptions,
                        buttons     : optionButtons
                    },
                )
            }else{
                buttons.push(optionButtons);
            }

        }

        // Export document print button
        if(enabledButtons.includes('export_document_print')){

            buttons.push(
                {
                    extend          : 'print',
                    text            : '<i class="fa-solid fa-print"></i> ' + window.trans.lms.DatatablesButtonsExportDocument,
                    autoPrint       : true,
                    className       : 'neutral',
                    exportOptions   : {
                        // Use one cell per exported row to read the participant data.
                        // DataTables still applies the current filtering, sorting and selection.
                        columns: [0],
                        // Type used in render function
                        orthogonal: 'document_export',
                        format: {
                            body: function(data, row) {
                                const participant = $('#' + additionalParameters.tableId).DataTable().row(row).data();
                                return [participant.last_name, participant.first_name, participant.id];
                            }
                        },
                        customizeData: function(data) {
                            const headers = ['Nr.', window.trans.lms.last_name, window.trans.lms.first_name, 'ID',
                                window.trans.lms.Signature, window.trans.lms.Signature, window.trans.lms.Signature];
                            const escapeHtml = value => String(value == null ? '' : value)
                                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                                .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

                            data.header = headers;
                            data.headerStructure = [headers.map(title => ({title, colspan: 1, rowspan: 1}))];
                            data.footer = [];
                            data.footerStructure = [];
                            data.body = data.body.map((row, index) => [index + 1,
                                ...row[0].map(escapeHtml), '', '', '']);

                            for (let i = 0; i < 5; i++) {
                                data.body.push(['', '', '', '', '', '', '']);
                            }
                        }
                    },
                    attr: {
                        id: 'exportDocumentPrint'
                    },
                    title           : '',
                    action          : function(e, dt, button, config) {

                        if(!handleDocumentExportButtonClick('meeting_participants', additionalParameters.tableId, config.attr.id)){return;}

                        // Allow some time for content to load
                        setTimeout(function(){$.fn.dataTable.ext.buttons.print.action(e, dt, button, config);}, 1000);

                    },
                    customize       : function (win) {

                        if(!exportDocumentTemplateSet){
                            return;
                        }

                        $(win.document.body).children('table').addClass('meeting-participants-document');

                        $(win.document.body)
                        // Insert html which goes before table
                        .prepend(contentBeforeTablePlaceholder)
                        // Insert html which goes after table
                        .append(contentAfterTablePlaceholder)
                            
                        // Set background
                        if(exportDocumentBase64Background !== ''){
                            
                            // Set for print
                            $(win.document.head).prepend(
                                '<style type="text/css" media="print">body{background-image:url("'+exportDocumentBase64Background+'") !important;background-repeat:repeat-y !important;background-position: right top !important; background-size:100% !important;}</style>'
                            );

                            // Set for print preview
                            $(win.document.body).attr('style',
                                'background-image:url("'+exportDocumentBase64Background+'") !important;background-repeat:no-repeat !important;background-position: right top !important; background-size:contain !important;'
                            );

                        }
    
                        $(win.document.body).find('thead tr th').attr('style', 'background-color:transparent !important;');
                        $(win.document.body).find('tbody tr td').attr('style', 'background-color:transparent !important;');
    
                        $(win.document.body)
                        .find('table')
                        .addClass('compact')
                        .css('font-size', 'inherit');

                        $(win.document.head).append(`
                            <style>
        table.meeting-participants-document {
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
        }
        table.meeting-participants-document th,
        table.meeting-participants-document td {
            border: 1px solid rgb(99,107,111);
            padding: 0.35em;
            height: 2em;
            overflow-wrap: anywhere;
        }
        table.meeting-participants-document th { width: 15%; }
        table.meeting-participants-document th:first-child { width: 5%; }
        table.meeting-participants-document th:nth-child(2),
        table.meeting-participants-document th:nth-child(3) { width: 20%; }
        table.meeting-participants-document th:nth-child(4) { width: 10%; }
        table.meeting-participants-document tr { page-break-inside: avoid; }
        body {
            font-family: 'Raleway',sans-serif;
            padding-left: 0.6em;
            padding-right: 0.6em;
            font-size: 56px; /* updated */
            line-height: 1.6; /* updated */
            color: rgb(99,107,111);
        }
        @font-face {
            font-family: 'Times New Roman';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/times.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Times New Roman';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/timesbd.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Times New Roman';
            font-style: italic;
            font-weight: normal;
            src: url({{ storage_path('fonts/timesi.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Times New Roman';
            font-style: italic;
            font-weight: bold;
            src: url({{ storage_path('fonts/timesbi.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Arial';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/arial.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Arial';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/arialbd.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Arial';
            font-style: italic;
            font-weight: normal;
            src: url({{ storage_path('fonts/ariali.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Arial';
            font-style: italic;
            font-weight: bold;
            src: url({{ storage_path('fonts/arialbi.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Verdana';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/verdana.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Verdana';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/verdanab.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Verdana';
            font-style: italic;
            font-weight: normal;
            src: url({{ storage_path('fonts/verdanai.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Verdana';
            font-style: italic;
            font-weight: bold;
            src: url({{ storage_path('fonts/verdanaz.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/Raleway-Regular.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/Raleway-Bold.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: lighter;
            src: url({{ storage_path('fonts/Raleway-Light.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            src: url({{ storage_path('fonts/Raleway-Medium.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Raleway';
            font-style: italic;
            font-weight: normal;
            src: url({{ storage_path('fonts/Raleway-Italic.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'TheSerifBPlus';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/TheSerifBPlus.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'TheSerifBPlusBold';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/TheSerifBPlusBold.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'CEWEText-Regular';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/CEWEText-Regular.ttf')}}) format('truetype');
        }

        @font-face {
            font-family: 'AvenirNextLTPro';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/f.otf')}}) format('opentype');
        }

        @font-face {
            font-family: 'NIVEABrandTypeBold';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/custom_fonts/NIVEABrandType-Bold.otf')}}) format('opentype');
            
        }

        @font-face {
            font-family: 'NIVEABrandTypeExtraBold';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/custom_fonts/NIVEABrandType-ExtraBold.otf')}}) format('opentype');
        }

        @font-face {
            font-family: 'NIVEABrandTypeLight';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/custom_fonts/NIVEABrandType-Light.otf')}}) format('opentype');
        }

        @font-face {
            font-family: 'NIVEABrandTypeMedium';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/custom_fonts/NIVEABrandType-Medium.otf')}}) format('opentype');
        }

        @font-face {
            font-family: 'NIVEABrandTypeRegular';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/custom_fonts/NIVEABrandType-Regular.otf')}}) format('opentype');
        }
        
        @font-face {
            font-family: 'NIVEABrandTypeSemiBold';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/custom_fonts/NIVEABrandType-SemiBold.otf')}}) format('opentype');
        }

        @font-face {
            font-family: 'OutfitBold';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/OutfitBold.ttf')}}) format('truetype');
        }
        
        @font-face {
            font-family: 'OutfitMedium';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/OutfitMedium.ttf')}}) format('truetype');
        }
        
        @font-face {
            font-family: 'NeusaNextProBold';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/NeusaNextPro-Bold.otf')}}) format('opentype');
        }
        
        @font-face {
            font-family: 'NeusaNextProMedium';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/NeusaNextPro-Medium.otf')}}) format('opentype');
        }

        @font-face {
            font-family: 'SiemensSans';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/SiemensSans_Prof_Roman.otf')}}) format('opentype');
        }

        @font-face {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/montserrat/Montserrat-Regular.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: medium;
            src: url({{ storage_path('fonts/montserrat/Montserrat-Medium.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Montserrat';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/montserrat/Montserrat-Bold.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Montserrat';
            font-style: italic;
            font-weight: normal;
            src: url({{ storage_path('fonts/montserrat/Montserrat-Italic.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Montserrat';
            font-style: italic;
            font-weight: medium;
            src: url({{ storage_path('fonts/montserrat/Montserrat-MediumItalic.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Montserrat';
            font-style: italic;
            font-weight: bold;
            src: url({{ storage_path('fonts/montserrat/Montserrat-BoldItalic.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Oswald';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/oswald/Oswald-Regular.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Oswald';
            font-style: normal;
            font-weight: medium;
            src: url({{ storage_path('fonts/oswald/Oswald-Medium.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Oswald';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/oswald/Oswald-Bold.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/opensans/OpenSans-Regular.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Open Sans';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/opensans/OpenSans-Bold.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Open Sans';
            font-style: italic;
            font-weight: normal;
            src: url({{ storage_path('fonts/opensans/OpenSans-Italic.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Open Sans';
            font-style: italic;
            font-weight: bold;
            src: url({{ storage_path('fonts/opensans/OpenSans-BoldItalic.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Spartan';
            font-style: normal;
            font-weight: normal;
            src: url({{ storage_path('fonts/spartan/Spartan-Regular.ttf')}}) format('truetype');
        }
        @font-face {
            font-family: 'Spartan';
            font-style: normal;
            font-weight: bold;
            src: url({{ storage_path('fonts/spartan/Spartan-Bold.ttf')}}) format('truetype');
        }
        #bg {
            position: fixed;
            width: 100% !important;
            height: 100% !important;
        }
        #bg img {
            position: absolute;
            top: 0;
            left: 0;
            min-width: 100% !important;
            min-height: 100% !important;

        }
        #content,
        #content_back {
            z-index: 1;
            margin-top: 0;
            padding: 0 0.6em;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            font-family: 'Raleway', sans-serif;
            padding-left: 0.6em;
            padding-right: 0.6em;
            font-size: 56px; /* updated */
            line-height: 1.6; /* updated */
            color: rgb(99, 107, 111);
            /* height: 100% !important; */
        }

        #content_back{
            page-break-after: avoid;
        }
        .wrapper-page{
            page-break-after: always;
        }
        .wrapper-page:last-child {
            page-break-after: avoid;
        }

        body{
            margin: 0 !important;
        }

        #background-image{
            width: 100% !important;
            height: 100% !important;
        }
        @page {
            margin: 0;
        }
        blockquote{
            overflow: hidden;
            padding-right: 1.5em;
            padding-left: 1.5em;
            padding-top: 44px; /* updated */
            padding-bottom: 44px; /* updated */
            margin-left: 0;
            margin-right: 0;
            font-style: italic;
            border-left: 20px solid #ccc;
            margin: 0 0 88px; /* updated */
            font-size: 70px; /* updated */
        }
        figure.table{
            /* margin: 7px auto; */
            display: table;
            width: 100%;
            position: relative;
            margin: 12px auto; /* updated */
            padding: 0;
        }
        figure.table table{
            border-collapse: collapse;
            border-spacing: 0;
            width: inherit;
            table-layout: fixed;
            margin: inherit;
        }
        .marker-yellow{
            background-color: #fdfd77;
        }
        .marker-green{
            background-color: #62f962;
        }
        .marker-pink{
            background-color: #fc7899;
        }
        .marker-blue{
            background-color: #72ccfd;
        }
        .pen-red{
            color: #e71313;
            background-color: transparent;
        }
        .pen-green{
            color: #128a00;
            background-color: transparent;
        }
        .btn-link{
            outline: none !important;
        }
        .text-huge{
            font-size: 1.8em;
        }
        .text-big{
            font-size: 1.4em;
        }
        .text-small{
            font-size: .85em;
        }
        .text-tiny{
            font-size: .7em;
        }
        figure.table table td, figure.table table th{
            min-width: 28px; /* updated */
            vertical-align: middle;
            line-height: unset;
        }
        h2 {
            font-size: 120px; /* updated */
        }
        h3{
            font-size: 96px; /* updated */
        }
        h4{
            font-size: 72px; /* updated */
        }


        h1, h2, h3, h4 {
            margin: 0;
        }
        h1, h2, h3, h4, h5, h6 {
            font-family: inherit;
            font-weight: 500;
            line-height: 1.1;
            color: inherit;
        }
        p{
            margin: 0;
            line-height: 1.2;
        }
        b, strong{
            font-weight: 700;
        }

        ul,ol{
            line-height: 1; /* updated */
            padding-left: 160px;
        }
        li{
            /* line-height: 1.2; */
        }
        .ck-content .table table td, .ck-content .table table th{
            padding: 0.4em;
            display: table-cell;
            vertical-align: middle;
        }
        table{
            display: table;
            line-height: 1.2;
            margin: 7px auto;
        }
        td{
            display: table-cell;
            padding: 0;
        }
        table td p{
            margin-bottom: 0;
            line-height: 1.2;
        }
        tr{
            display: table-row;
        }
        tbody{
            display: table-row-group;
        }
        figure.image{
            margin-left: 0;
            margin-right: 64px; /* updated */
            display: block;
            position: relative;
            clear: both;
        }
        figure.image > img{
            display: block;
            max-width: 100%;
            min-width: 100px;
            width: 100%;
        }
        .image-style-align-left {
            float: left;
        }
        .image-style-align-right {
            float: right;
        }
        .image-style-align-center{
            display: block;
            margin-left: auto !important;
            margin-right: auto !important;
        }
        span{
            border-top: 12px solid transparent; /* updated */
        }
        .placeholder{
            display: inline;
            background: transparent;
        }
        .user_profile_picture{
            vertical-align: baseline;
            height: 800px; /* updated */
            width: auto;
        }
        .placeholder-image{
            display: inline-block;
            vertical-align: baseline;
            height: 800px; /* updated */
            width: auto;
        }
        table, tr, th, td{
            page-break-inside: auto;
        }
        .qr-code{
            position: inherit !important;
        }

        @media only screen and (min-width: 500px) {
            .certificate-content {
                width: 100% !important;
                /* height: 100% !important; */
                inline-size: 390px;
                overflow-wrap: break-word;
                /* font-size: 36px !important;  */
                max-width: 100% !important; 
                /* max-height: 896px; */
            }
        }
        @media only screen and (max-width: 500px) {
            .certificate-content {
                width: 100% !important;
                height: 100% !important;
                inline-size: 390px;
                overflow-wrap: break-word;
                font-size: 10px !important;
                max-width: 450px;
                max-height: 896px;
            }
        }

        .frontend-hidden{display:none}.landscape-form{min-width:1123px!important;width:1123px!important;margin:0 auto}.portrait-form{min-width:794px!important;width:794px!important;margin:0 auto}.a8-form{min-width:1012px!important;width:1012px!important;margin:0 auto}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:wrap!important}.overlay{z-index:1000!important}.ck-content{padding-top:7px!important;line-height:normal!important}.ck-editor__editable_inline{min-height:300px;position:relative;line-height:22px;overflow:hidden}.ck-editor__editable_inline h2,.ck-editor__editable_inline h3{margin:0;color:inherit!important}.ck-editor__editable_inline p{margin:0;margin-bottom:7px;line-height:1.2}.ck-content .table table td,.ck-content .table table th{border:none}.ck-content .table table{border:none}.ck-content .table{margin:7px auto}.ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}#background-image{max-width:100%}.placeholder-image{text-align:center;vertical-align:bottom;display:inline-block;width:180px;height:200px}.ck-list{max-height:400px;overflow:auto}.ck-editor .h1,.ck-editor .h2,.ck-editor .h3,.ck-editor h1,.ck-editor h2,.ck-editor h3{margin:0!important;font-size:2em!important}.ck-content .table table td,.ck-content .table table th{padding:0}.ck-content ul li{line-height:1.2}.invisible{visibility:hidden}.ck-font-size-dropdown .ck.ck-list__item .ck-button .ck-button__label{line-height:inherit}

        .watermark-text{
            -webkit-transform: rotate(331deg);
            -moz-transform: rotate(331deg);
            -o-transform: rotate(331deg);
            transform: rotate(331deg);
            font-size: 12em;
            color: rgba(255, 5, 5, 0.3);
            position: fixed;
            text-transform:uppercase;
            top: 20%;
            width: 100%;
            text-align: center;
            z-index: 10000 !important;
            font-weight: bold;
            padding: 0;
            margin: 0;
        }
                            </style>
                        `);

                        exportDocumentTemplateSet = false;

                    }
                }
            )
        }

        // Archive button for meetings
        if(enabledButtons.includes('archive')){
            buttons.push({
                text: finalizeTranslation,
                className: 'positive',
                action:function(){
                    confirmArchiveMeeting();
                }
            });
        }

        // Unarchive button for meetings
        if(enabledButtons.includes('unarchive')){
            buttons.push(
                {
                    text: openMeetingTranslation,
                    className: 'positive',
                    action:function(){
                        openArchivedMeetingConfirm();
                    }
                }
            )
        }

        return buttons;
    }

    const config = {
        dom             : '<"datatables-search"<lB>f>r<"custom-table-wrapper"t><"datatables-footer"ip>',
        colReorder      : {
            enable:false,
            columns: ':not([data-reorderable="false"])'
        },
        deferRender     : true,
        autoWidth       : false,
        locale          : window.User.locale,
        buttons         : setDatatablesButtons(),
        order           : [0, 'asc'],
        responsive      : window.global_vars && !window.global_vars.masterdata.settings.max_accessibility,
        language        : {
            processing      : '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">'+ window.trans.lms.Loading +'</span>',
            search          : window.trans.lms.Search,
            paginate        : {
                next        : window.trans.lms.Next,
                previous    : window.trans.lms.Previous
            },
            emptyTable      : window.trans.lms.EmptyTable,
            infoEmpty       : window.trans.lms.InfoEmpty,
            lengthMenu      : window.trans.lms.Show + ' _MENU_ ' + window.trans.lms.entries,
            info            : '<p>' + infoTranslations + '</p>',
            infoFiltered    : window.trans.lms.filteredFrom + ' _MAX_ ' + window.trans.lms.total +' '+ window.trans.lms.entries,
            zeroRecords     : window.trans.lms.ZeroRecords,
            aria: { //TODO
                sortAscending   : '',
                sortDescending  : ''
            }
        },
        pageLength      : 10,
        //TODO: make sure pagination is accessible instead of disabling it
        paging          : window.global_vars && !window.global_vars.masterdata.settings.max_accessibility,
        pagingType      : "simple_numbers",
        drawCallback    : function(settings = {}) {

            var pagination = $(this).closest('.dt-container').find('.dt-paging');

            pagination.toggle(this.api().page.info().pages > 1);

            let nextButton = pagination.find('.next');
            
            if(nextButton){

                let max = Number(this.api().page.info().pages) ? Number(this.api().page.info().pages) : 1;
                let element = '<li class="dt-paging-button page-item"><input autocomplete="off" class="jump-to-page" type="number" min="1" max="'+ max +'" value="'+ Number(this.api().page() + 1) +'"></input></li>';

                nextButton.after(element);

                $('.jump-to-page').on('change', function(e){
                    window.goToPage(this);
                });

            }

            if(settings['bFiltered'] === false){
                return;
            }

            let $tableNode = $(this.api().table().node());
            
            if($tableNode.data('search-settings') === undefined){
                $tableNode.data('search-settings', {});
            }

            let $tableHeader = $(this.api().table().header());
            let $tableFooter = $tableHeader.parent().find('tfoot');

            if($tableFooter.length === 0){ //first table load
                let $footerRow = $('<tr>')
                    .addClass('column-active'); //applies the colours from the masterdata

                $tableFooter = $('<tfoot>')
                    .css('display', 'table-header-group') //makes it so it gets displayed below the header row
                    .append($footerRow)
                    .toggle($tableNode.data('search-settings')['on'] || false);
                $tableHeader.after($tableFooter); //table footer needs to placed after table header according to HTML5

                this.api()
                    .columns()
                    .every(function () {
                        let column = this;

                        let $td = $('<td>')
                            .addClass('search-row-cell')
                            .on('enable', () => {
                                if($(column.header()).is(':hidden')){
                                    $td.hide();
                                }
                            });

                        // Elements with class 'no-filter' shouldn't have search field
                        if($(column.header()).hasClass('sorting_disabled') || $(column.nodes()).first().find(">:first-child").is('input') || $(column.header()).hasClass('no-filter')){
                            $footerRow.append($td);
                            return;
                        }

                        let $input = $('<input>')
                            .attr('placeholder', window.trans.lms.Search)
                            .css('width', '100px')
                            .css('fontWeight', 'normal')
                            .addClass('form-control form-control-sm search-row-cell')
                            .val($tableNode.data('search-settings')[column.index()] || '');

                        $input.on('keyup', () => {
                            let inputVal = $input.val();
                            if(column.search() !== inputVal) {
                                $tableNode.data('search-settings')[column.index()] = inputVal;
                                column.search(inputVal).draw();
                            }
                        });

                        $input.on('disable', () => {
                            column.search('').draw();
                        });

                        $input.on('enable', () => {
                            let inputVal = $input.val();
                            if(inputVal !== ''){
                                column.search(inputVal).draw();
                            }
                        });

                        $footerRow.append($td.append($input));

                        if(window.global_vars.masterdata.settings.max_accessibility) {
                            $input.wrap($('<label>').text(window.trans.lms.Search));
                        }
                    });

                if($tableFooter.is(':visible')){
                    $tableFooter.find('.search-row-cell').trigger('enable');
                }
            }

            let $searchRowToggleButton = $(this).closest('.dt-container').find('.search-row-toggle-button');
            if($searchRowToggleButton.length === 0){
                $searchRowToggleButton = $('<button>')
                    .attr('type', 'button')
                    .addClass('positive search-row-toggle-button')
                    .html('<i class="fa-solid fa-filter"></i>')
                    .css('marginRight', '5px')
                    .attr('title', trans.lms.SearchFilters)
                    .attr('aria-pressed', 'false')
                    .attr('aria-describedby', 'search-row-toggle-description');
                $searchRowToggleButton.append($('<span>').addClass('sr-only').text(window.trans.lms.ColumnSearchToggleDescription));
                //Put the toggle button just before the search box
                $(this.api().table().container()).find('input').first().parent().prepend($searchRowToggleButton);
            }

            $searchRowToggleButton.off('click').on('click', () => {
                $tableFooter.toggle();
                if($tableFooter.is(':visible')){
                    $tableNode.data('search-settings')['on'] = true;
                    $tableFooter.find('.search-row-cell').trigger('enable');
                    $searchRowToggleButton.attr('aria-pressed', 'true');
                } else{
                    $tableNode.data('search-settings')['on'] = false;
                    $tableFooter.find('.search-row-cell').trigger('disable');
                    $searchRowToggleButton.attr('aria-pressed', 'false');
                }
            });

            setTimeout(() => {
                let firstColumnNodes = this.api().column(0).nodes();
                if(firstColumnNodes){
                    firstColumnNodes.to$().removeAttr('tabindex');
                }

                let $th = $tableHeader.find('th').removeAttr('aria-label').removeAttr('aria-controls');
                $th.each((i, th) => {
                    if(th.tabIndex >= 0 && th.getElementsByTagName('span').length === 0 && th.innerText.trim().length > 0) {
                        let newSortToggle = document.createElement('span');
                        newSortToggle.setAttribute('role', 'button');
                        newSortToggle.setAttribute('tabindex', '0');
                        newSortToggle.innerText = th.innerText;
                        th.innerText = '';
                        th.title = window.trans.lms.column_headers_sortable;
                        th.appendChild(newSortToggle);
                        th.removeAttribute('tabindex');
                    }
                });
            }, 0);

            let exportButton = $tableNode[0].closest('div.dt-container').querySelector('button.buttons-excel');
            if(exportButton){
                exportButton.removeAttribute('tabindex');
                exportButton.removeAttribute('aria-controls');
                exportButton.setAttribute('title', window.trans.lms.exportTable);
            }
        },
        createdRow: function (row, data, dataIndex) {
            
            let did = '';

            if(data.customRowId){
                did = data.customRowId;
            }else{
                did = (data.cid || data.temi || data.uppid || data.cmid || data.h5pid) + "" + (data.uid || data.id);
            }

            did = did.replace('undefined', '');

            $(row).attr('data-id', data.id);
            $(row).attr('id', did);
        }
    }
    /**
     * 
     * @param {*} options -- object with options to override default config
     * @returns 
     */
    window.setDatatableOptions = function(options = {}){
        const datatableOptions = {};
        for(const property in config){
            datatableOptions[property] = config[property];
            if(property == 'pageLength'){
                datatableOptions[property] = sessionStorage.getItem('pageLength') ? Number(sessionStorage.getItem('pageLength')) : Number(window.datatablesConfig[property]);
            }
        }
        for(const property in options){
            datatableOptions[property] = options[property];
        }

        datatableOptions['initComplete'] = function () {
            let $inputs = $(this.api().table().container()).find('input');
            $inputs.attr('autocomplete', 'off');

            let tableContainer = options && options.tableContainer ? options.tableContainer : 'table';
            hideDtLoader(tableContainer);
            let allTables = $.fn.dataTable.tables();
            allTables.forEach(function(table){
                $('#' + table.id).on('length.dt', function () { // check if jquery can be removed here
                    let select = document.getElementsByName(table.id + "_length")[0];
                    if(typeof select !== 'undefined'){

                        let newValue = select.options[select.selectedIndex].value;

                        // send AJAX request for updating session values
                        updateShowEntries(newValue);
                    }
                })
            });

            let $footer = $(this.api().table().footer());

            if($footer.length > 0){
                $footer.remove();
                this.api().draw();
            }

        }

        //prevent overwriting
        datatableOptions['drawCallback'] = function(settings) {
            if(config['drawCallback']) {
                config['drawCallback'].apply(this, [settings]);
            }
            if(options && options['drawCallback']){
                options['drawCallback'].apply(this, [settings]);
            }
            // No data available across entire table
            setTimeout(function () {
                $('.dt-empty').attr('colspan', '100%');
            }, 100);
        }

        return datatableOptions;
    }

    function hideDtLoader(container){
        let spinner = document.getElementById(container+"_loader");
        let pageContainer = document.getElementById(container);
        
        if(pageContainer){
            pageContainer.style = "visibility: visible";
            pageContainer.classList.add('dt_expand');
        }
        if(spinner){
            spinner.style = "visibility: hidden";
        }
    }

    function updateShowEntries(newValue) {
        // send AJAX request for updating session values
        $.ajax({
            type: 'PUT',
            url: '/entries/show',
            data: {
                'entries': newValue
            },
            success: function () {
                document.body.dataset.entries = newValue;
                sessionStorage.setItem('pageLength', newValue);
            }
        });
    }

    window.goToPage = function(table){
        let value = Number(event.target.value) - 1;
        if(value < 0){
            value = 0;
        }
        table.api().page(value).draw(false);
    }
    window.hideDtLoader = hideDtLoader;
    window.datatablesConfig = config;

    function exportBodyText(data) {
        if (data === null || typeof data === 'undefined') {
            return '';
        }

        if (typeof data !== 'string') {
            return data;
        }

        if (!data.includes('<')) {
            return data;
        }

        try {
            return $('<div>').html(data).text().trim();
        } catch (error) {
            return data.replace(/<[^>]*>/g, '').trim();
        }
    }

    function exportColumnData(data, row, column, node) {
        if (!node) {
            return exportBodyText(data);
        }

        // Icons for LMS message or mail - system messages statistics
        if ($(node).find('i.fa-at, i.fa-envelope').length > 0) {
            return window.trans.lms.Yes;
        }

        // Checkboxes
        const $checkbox = $(node).find('input[type="checkbox"]');
        if ($checkbox.length) {
            return $checkbox.is(':checked') ? '1' : '0';
        }

        // Select dropdowns
        if (typeof node.cellIndex === 'undefined') {
            return exportBodyText(data);
        }

        const cellIndex = node.cellIndex;
        const rowIndex = $(node).closest('tr').index();
        const originalTd = $('table.dataTable tbody tr')
            .eq(rowIndex)
            .find('td')
            .eq(cellIndex);

        const selects = originalTd.find('select');

        if (selects.length === 0) {
            return exportBodyText(data); 
        }

        const visibleSelect = selects.filter(function () {
            return $(this).closest('.bootstrap-select').is(':visible');
        }).first();

        if (visibleSelect.length === 0) {
            return exportBodyText(data);
        }

        // Selected option
        const selected = visibleSelect.find('option:selected').text().trim();

        return selected || exportBodyText($(node).text().trim());
        
    }
    
}
